import { getLabel } from '../InitData';
import { playableInMultiple } from './purchase-service';
import {
    convertToDecimalWithPrecision,
    getAmountInCent, getConfiguration, getDateFromTimestamp, multiplyAndRound,
    oddToString, roundNumber, truncateToDecimal
} from './utils';

export const BONUS_TYPE = {
		0 : "NO_BONUS",
		1 : "IMPORTO",
		2 : "PERCENTUALE",
		3 : "PERCENTUALE2",
		4 : "FASCE"
};

export function getBonusSingle(user, bonusData, selections, amount, winning){
	if(bonusData == null){
		return {
			bonusAmount : 0.00,
			totalWinWithBonus : 0.00,
			minEvents : 0,
			eventList : [],
			appliedPercentage : 0.00,
			fasce : {},
			bonusElements : [],
			description : "",
			applied : false
		}
	}
	let dataBonus = bonusData.unloggedPromoBonus;
	const result = {
			bonusAmount : 0.00,
			totalWinWithBonus : 0.00,
			minEvents : dataBonus?.numeroMinimoAvvenimenti,
			eventList : [],
			appliedPercentage : 0.00,
			fasce : dataBonus?.tabellaBonus,
			bonusElements : [],
			description : dataBonus?.descrizioneBonus,
			applied : false
	};
	
	return result;
}

function getRestoredSelectionsForLegabileMarkets(selectionsInput){
	 const selections = [];
	 for(let k in selectionsInput){
	 	const selection = selectionsInput[k];
	 	const playableInMulti = playableInMultiple(selection.bets);
	 	// push for the first bet
	 	if(selection.bets.length > 1 && playableInMulti){
	 		//selections.push(selection);
	 		for(let km = 0; km < selection.bets.length; km ++){
	 			if(selection.bets[km].legabile){
	 				const duplicatedSelection = JSON.parse(JSON.stringify(selection));
	 				duplicatedSelection.bets = [];
	 				// pushing the legabile market as it is the first one
	 				duplicatedSelection.bets.push(selection.bets[km]);
	 				// save the fake selection in the final array
	 				selections.push(duplicatedSelection);
	 			}
	 		}
	 	}
	 	else{
	 		selections.push(selection);
	 	}
	 }
	 return selections;
}

export function getBonusMultiple(user, bonusData, selectionsInput, winning, isRealMoney){

	const conf = getConfiguration();
	// if this is not a real money purchase (freebet or funbonus) and obw = false, then I skip the calcs
	const avoidCalcs = !isRealMoney && !conf.obw;
	if(bonusData == null || avoidCalcs){
		return {
			multipleBonus : {	
				bonusAmount : 0.00,
				totalWinWithBonus : 0.00,
				minEvents : 0,
				eventList : [],
				appliedPercentage : 0.00,
				fasce : {},
				bonusElements : [],
				description : "",
				applied : false
			},
			toGetBonus : null
		}
	}
	// getting the real selections array. If in a selection there are more than 1 bet, I'll take the first one and all the "legabili"
	const selections = getRestoredSelectionsForLegabileMarkets(selectionsInput);
	//ATTENTION! amount and winning must be already formatted in double (no cents)

	
	let nDec = conf.cs.nd;
	let mult = conf.cs.m;
	let dataBonus = bonusData.bonusMultiple;
	if(user && user.logged && !user.bonusEnabled){
	 	dataBonus = bonusData.unloggedPromoBonus;		
	}
	const result = {
			bonusAmount : 0.00,
			totalWinWithBonus : 0.00,
			minEvents : dataBonus.numeroMinimoAvvenimenti,
			eventList : [],
			appliedPercentage : 0.00,
			fasce : dataBonus.tabellaBonus,
			bonusElements : [],
			description : dataBonus.descrizioneBonus,
			applied : false
	};
	let toGetBonus = {
			showAdvise : false	
	};
	
	const bonusType = BONUS_TYPE[dataBonus.bonus];
	
	if(bonusType !== "NO_BONUS" && selections && selections.length > 0) {
		let minimumOdd = dataBonus.tabellaQuoteMinime[selections.length];
		minimumOdd = minimumOdd == null? 0 : minimumOdd;
		minimumOdd = minimumOdd == 0? dataBonus.quotaMinima : minimumOdd;
		
		let allSelectionsAreInRange = true;
		for(let k in selections){
			let selection = selections[k];
			if(!selection.closed){
				const bet = selection.bets[0];
				if(!bet.closed){
					// check if the market is avaialable for this bonus
					const scomSogei = bet.scomSogei;
					let validMarket = true;
					let validEvent = true;
					const validSport = !dataBonus.sportProvider?.[selection.sportId];
					const validTournament = !dataBonus.tournamentProvider?.[selection.tournamentId];
					
					if(selection.isLive == false) {
						if(dataBonus.scommesseDaEscluderePrematch[scomSogei] != null) {
							validMarket = false;
						}
					}
					else if(selection.isLive) {
						if(dataBonus.scommesseDaEscludereLive[scomSogei] != null) {
							validMarket = false;
						}
					}
					
					let maxValidity = dataBonus.giorniMax;
					
					if(maxValidity != null && maxValidity > 0){
						// I have to accept in this calculation just the events starting now until now + maxValidity days.
						// EX: maxValidity = 1, now is 3:50 PM, then all the events starting from now tomorrow 3:50 PM  are ok.
						const eventDate = getDateFromTimestamp(selection.timestamp);
						let nowTime = new Date();
						let days = nowTime.getDate() + maxValidity;
						nowTime.setDate(days);
						validEvent = nowTime.getTime() > eventDate.getTime();
						if(validEvent == false){
							allSelectionsAreInRange = false;
						}
					}

					
					
					// this selection is checked-in
					if(validSport && validTournament && validEvent && validMarket){
						if(dataBonus.filtroQuota != null && dataBonus.filtroQuota[selection.sportId] != null){
							if((selection.bets[0].odd / 100) >= dataBonus.filtroQuota[selection.sportId]){
								result.bonusElements.push(selection);
							}
						}
						else{
							if((selection.bets[0].odd) >= minimumOdd && minimumOdd > 0){
								result.bonusElements.push(selection);
							}
						}
					}
				}				
			}	
		}
		
		// there is a no valid selection for the time range setted
		// kbeo means that I've to keep all the events in the time range, keeping the bonus on them. 
		// Default is false, it means that the entire bonus is deleted.
		if(allSelectionsAreInRange == false && !conf.kbeo){
			result.bonusElements = [];
		}
	}
	if(bonusType === "FASCE") {
		const numSelections = result.bonusElements.length;
		if(numSelections >= dataBonus.numeroMinimoAvvenimenti) {
			const percentage = dataBonus.tabellaBonusOrig?.[numSelections];
			if(percentage) {
				result.appliedPercentage = dataBonus.tabellaBonus[numSelections]; 
				const bonusIncrementOdd = parseFloat(10000 + percentage) / 10000;
				const totalWinWithBonus = bonusIncrementOdd * winning;
				const bonusAmount = convertToDecimalWithPrecision(totalWinWithBonus - winning, 19, 6); // solo un reminder: sarebbe l'originale senza arrotondamenti
				const potentialWinningNoBonus = totalWinWithBonus - bonusAmount;
				result.totalWinWithBonus = parseInt(totalWinWithBonus);
				result.potentialWinningNoBonus = parseInt(potentialWinningNoBonus);
				result.bonusAmount = result.totalWinWithBonus - result.potentialWinningNoBonus; // mi adeguo al dettaglio ticket dal db e perdo un po' di precisione: lo mostro direttamente eliminando ogni parte decimale dai due addendi

				for (var i in result.bonusElements) {
					const obj = {
					pal : result.bonusElements[i].pal,
					avv : result.bonusElements[i].avv
					};
					result.eventList.push(obj);
				}
				
				result.applied = true;
			}
		}
		
		// TO GED BONUS ADVISE
		const toGetBonusConfig = getConfiguration().tgb;
		const goOnEvenIfTheBonusIsApplied = result.applied && toGetBonusConfig.goba;
		const calculateAdvise = toGetBonusConfig && 
								toGetBonusConfig.showable && 
								!window.appConfig.TERMINAL_AGENCY 
								&& (!result.applied || goOnEvenIfTheBonusIsApplied);
		if(calculateAdvise){
			let nextBonusThreshold = dataBonus.numeroMinimoAvvenimenti;
			// I switch the threshold map in a sorted array
			let thresArray = [];
			let lowestPercentage = 0;
			let highestPercentage = 0;
			for(let km in dataBonus.tabellaQuoteMinime){
				thresArray.push(parseInt(km));
				if(dataBonus.tabellaBonus[km]){
					const percentage = dataBonus.tabellaBonus[km];
					if(percentage < lowestPercentage || lowestPercentage == 0){
						lowestPercentage = percentage;
					}
					if(percentage > highestPercentage || lowestPercentage == 0){
						highestPercentage = percentage;
					}
				}
			}
			// sorting the threashold array, I'm not sure that the earlier loop pushes the map key in ascendent order
			thresArray.sort(function(a, b) {
				  return a - b;
			});

			
			for(let km in thresArray){
				const thres = thresArray[km];
				const keyTh = thres + "";
				if(dataBonus.tabellaBonus[keyTh] > 0 && thres >= dataBonus.numeroMinimoAvvenimenti){
					if(!result.applied){
						nextBonusThreshold = thres;
						break;
					}
					else{
						// if the bonus has been applied, then I've to take the next threshold with a percentage higher than the applied one
						if(thres > numSelections && dataBonus.tabellaBonus[keyTh] > result.appliedPercentage){
							nextBonusThreshold = thres;
							break;
						}
					}
				}
			}
			toGetBonus.nextBonusThreshold = nextBonusThreshold;
			toGetBonus.eventLeftToGetBonus = nextBonusThreshold - numSelections;
			if(toGetBonus.eventLeftToGetBonus < 0){
				toGetBonus.eventLeftToGetBonus  = 0;
				toGetBonus.showAdvise = false;
			}
			else {
				let minimumOdd = dataBonus.tabellaQuoteMinime[nextBonusThreshold];
				minimumOdd = minimumOdd == null? dataBonus.quotaMinima : minimumOdd;
				minimumOdd = minimumOdd == null? 0 : minimumOdd;
				toGetBonus.minimumOdd = minimumOdd;
				let percentage = dataBonus.tabellaBonus[nextBonusThreshold];
				percentage = percentage? percentage : 0;
				toGetBonus.reachingPercentage = multiplyAndRound(percentage, 100);
				toGetBonus.lowestPercentage  = multiplyAndRound(lowestPercentage, 100);
				toGetBonus.highestPercentage  = multiplyAndRound(highestPercentage, 100);
				const recipientLevel =  parseInt((numSelections * 100) / nextBonusThreshold);
				// I will show ad advise if the number of "bonusable" events are gt thresholdPercentage% of the number needed to activate the bonus
				// f.e. 5 elements to activate bonus, 3 events in the cart: 60%, i will show: "put 2 more events to activate the bonus"
				toGetBonus.showAdvise = recipientLevel >= toGetBonusConfig.thresholdPercentage;
		    	let bonusAdvise = toGetBonus.eventLeftToGetBonus === 1? getLabel('betslip.bonus_advise.one_left') : getLabel('betslip.bonus_advise.events_left');
		    	bonusAdvise = bonusAdvise.replace(/{{TO_ADD_NUM}}/g, toGetBonus.eventLeftToGetBonus);
		    	bonusAdvise = bonusAdvise.replace(/{{ODD}}/g, oddToString(toGetBonus.minimumOdd));
		    	bonusAdvise = bonusAdvise.replace(/{{PERCENTAGE}}/g, toGetBonus.reachingPercentage);
		    	bonusAdvise = bonusAdvise.replace(/{{LOWEST_PERCENTAGE}}/g, toGetBonus.lowestPercentage);
		    	bonusAdvise = bonusAdvise.replace(/{{HIGHEST_PERCENTAGE}}/g, toGetBonus.highestPercentage);
		    	bonusAdvise = bonusAdvise.replace(/{{BONUS_NAME}}/g, dataBonus.descrizioneBonus);			
				toGetBonus.bonusAdvise = bonusAdvise;
				toGetBonus.reachedPercentage = result.applied? multiplyAndRound(result.appliedPercentage, 100) : null;
			}

		}
		
	}
	return {
		multipleBonus : result,
		toGetBonus
	}
}

function getPercentageInt(doubleVal){
	let beforeDot = "0";
	let afterDot = "0";
	let stringedDouble = doubleVal + "";
	let multiplier = 10000;
	while(multiplier != 1) {
		let parts = stringedDouble.split(".");
		beforeDot = parts[0];
		afterDot =  parts.length == 2?  parts[1] : "";
		if(afterDot.length == 0) {
			// ho esaurito i numeri dopo la virgola: aggiungo lo zero (moltiplico per 10)
			beforeDot = beforeDot + "0";
		}
		else {
			// muovo la virgola a destra spostando il primo carattere dopo la virgola prima di questa (moltiplico per 10)
			beforeDot = beforeDot + afterDot.charAt(0);
			afterDot = afterDot.substring(1);
		}
		// casto a long la parte intera (così gestisco il caso in cui mi trovo 00.10) e ricostruisco il nuovo double
		stringedDouble = parseInt(beforeDot) + (afterDot.length > 0? ("." + afterDot) :"");
		multiplier /= 10;
	}
	const finalInt = parseInt(beforeDot + afterDot);
	return finalInt;
}

export function getBonusSystem(user, bonusData, selections){
	const bonusSystem = {};
	bonusSystem.discipline = [];
	bonusSystem.soglia_quota = 0;
	bonusSystem.tipobonus = 0;
	bonusSystem.bonusrows = [];
	bonusSystem.description = null;
	
	if(bonusData == null){
		return bonusSystem;
	}
	let dataBonus = bonusData.bonusSystems;
	if(user && user.logged && !user.bonusEnabled){
	 	dataBonus = bonusData.unloggedPromoBonus;		
	}
	let bonusRows = [];
	for(let i in dataBonus.tabellaBonus){
		bonusRows.push({
			bonus : getPercentageInt(dataBonus.tabellaBonus[i]), //  it is a percentage value represented in cents, so 100*100
			filtro : 0, // 0 fixed
			min_avv : i,
			sistema : i // "5", "6", ... "31"
		});	
	}
	let realSelNum = 0;
	for(let k in selections){
		if(!selections[k].closed){
			const validSport = !bonusData.sportProvider?.[selections[k].sportId];
			const validTournament = !bonusData.tournamentProvider?.[selections[k].tournamentId];
			if(validSport && validTournament){
				let thereAreLeg = false;
				for(let kb in selections[k].bets){
					if(selections[k].bets[kb].legabile){
						// a leg selections must be taken as a new event
						realSelNum ++;
						thereAreLeg = true;
					}
				}
				if(!thereAreLeg){
					realSelNum ++;				
				}			
			}
		}
	}
	let minimumOdd = dataBonus.tabellaQuoteMinime[realSelNum];
	minimumOdd = minimumOdd == null? dataBonus.quotaMinima : minimumOdd;
	minimumOdd = minimumOdd == null? 0 : minimumOdd;
	
	bonusSystem.discipline = dataBonus.discipline;
	bonusSystem.soglia_quota = minimumOdd;
	bonusSystem.tipobonus = dataBonus.bonus;
	bonusSystem.bonusrows = bonusRows;
	bonusSystem.description = dataBonus.descrizioneBonus;
	return bonusSystem;
}

export function calcBonusMinMaxSystem(calculatedSysData, userSelections, couponSelections){
	
	let bonusMax = 0;
	let bonusMin = 0;
	
	if(calculatedSysData != null && calculatedSysData.v_maxpotbonus != null && calculatedSysData.v_minpotbonus != null){

		let checkboxArray = [];
		for(let k in userSelections){
			checkboxArray.push(userSelections[k].selected);
		}
        for(let i = 0; i < calculatedSysData.v_maxpotbonus.length; i++){
    		if(checkboxArray[i]){
    			bonusMax += calculatedSysData.v_maxpotbonus[i];
    		}
        }
        
        if(isIntegralSystemBet(couponSelections) == false){
            for(let i = 1; i < calculatedSysData.v_minpotbonus.length; i++){
        		if(checkboxArray[i]){
		        	if(calculatedSysData.v_minpotbonus[i] != 0){
		        		if(bonusMin == 0){
		        			bonusMin = calculatedSysData.v_minpotbonus[i];
		        		}else{
		        			if(calculatedSysData.v_minpotbonus[i] < bonusMin){
		        				bonusMin = calculatedSysData.v_minpotbonus[i];
		        			}
		        		}
		        	}
        		}
	        }
        }
        else{
        	for(var i = 1; i < calculatedSysData.v_minpotbonus.length; i++){
        		if(checkboxArray[i]){
        			bonusMin += calculatedSysData.v_minpotbonus[i];
        		}
   	        }
        }
	}
	let conf = getConfiguration();
	let nDec = conf.cs.nd;
	bonusMin = bonusMin.toFixed(nDec);
	bonusMax = bonusMax.toFixed(nDec);
	return {
		bonusMin : bonusMin,
		bonusMax : bonusMax
	};

}

export function isIntegralSystemBet(selections){
	let integral = true;
	for(let ke in selections){
		integral = integral && selections[ke].bets.length == 1;
		if(integral == false){
			break;
		}
	}
	return integral;
}
